<template>
  <div>
    <div v-if="sites && sites.length">
      <div class="top-controls">
          <b-input-group class="filter-group">
            <b-input-group-prepend is-text>
              <font-awesome-icon icon="search" />
            </b-input-group-prepend>
            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
              <b-button @click="filter = null">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </div>

      <b-table striped 
               :items="sites"
               :fields="fields"
               :per-page="perPage"
               :current-page="currentPage"
               :filter="filter"
               @filtered="onFiltered"
               small>
        <template slot="view" slot-scope="data">
          <router-link :to="{ name: 'site', params: { siteId: data.item.siteId } }">View</router-link>
        </template>
      </b-table>

      <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
    </div>
    <p v-if="sites && !sites.length">There are no sites to show.</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fields: [{ key: "name" }, { key: "view", label: "" }],
      currentPage: 1,
      perPage: 10,
      filter: null,
      totalRows: 0
    };
  },

  props: {
    sites: {
      type: Array,
      required: true
    }
  },

  watch: {
    sites: function() {
      this.totalRows = this.sites.length;
    }
  },

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
.top-controls {
  margin-bottom: 10px;
}

.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
  display: inline-flex;
}
</style>
